import { parseItemKey } from './craftingResolver';
import type { ItemStack } from '../models/itemStack';

export interface SellbotReasonItem {
    itemKey: string;
    count: number;
    stack: ItemStack;
}

export function parseSellbotReasonItems(argsJson?: string | null): SellbotReasonItem[] {
    if (!argsJson) return [];
    let args: Record<string, any>;
    try { args = JSON.parse(argsJson); } catch { return []; }
    if (!Array.isArray(args?.items)) return [];

    const parsed: SellbotReasonItem[] = [];
    for (const entry of args.items) {
        const itemKey = reasonItemKey(entry);
        if (!itemKey) continue;
        const ids = parseItemKey(itemKey);
        if (!ids) continue;
        const count = Number(entry.count);
        if (!Number.isFinite(count) || count <= 0) continue;
        parsed.push({
            itemKey,
            count,
            stack: { itemId: ids.id, count, damage: ids.metadata, snbt: entry.snbt ?? undefined },
        });
    }
    return parsed;
}

// Trash chest deposits stored the id and the damage in separate fields, so rows already in the
// database carry that shape instead of the "id:damage" key every other reason payload uses.
function reasonItemKey(entry: Record<string, any>): string | null {
    if (typeof entry?.item === 'string') return entry.item;
    if (typeof entry?.itemId === 'number') return `${entry.itemId}:${entry.damage ?? 0}`;
    return null;
}
